import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; 

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Royal Route Cab | Terms & Conditions</title>
        <meta 
          name="description" 
          content="Terms & Conditions for Royal Route Cab Services" 
        />
      </Helmet>


  <div
      className="breadcrumb-wrapper section-padding bg-cover"
      style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
    >
      <div className="container-fluid">
        <div className="page-heading">
          
          <h1 className="wow fadeInUp text-center" data-wow-delay=".5s">
            Terms & Conditions
          </h1>
        </div>
      </div>
    </div>

   

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b> <br/>
                  All Royal Route Cab bookings are subject to vehicle availability. 
                  Confirmation will be provided after advance payment or approval from our team.
                </p>

                <p>
                  <b className="highlight">2. Vehicle Usage:</b> <br/>
                  Vehicles are strictly for passenger transport. Carrying commercial goods 
                  or illegal items is prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b> <br/>
                  Payments can be made via online transfer, UPI, or cash. 
                  Advance payment is required for outstation, wedding, or corporate bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b> <br/>
                  Cancellations must be made in advance. Charges may apply based on 
                  timing and booking type.
                </p>

                <p>
                  <b className="highlight">5. Passenger Responsibility:</b> <br/>
                  Customers must provide accurate pickup details. 
                  Delays due to incorrect information may result in waiting charges.
                </p>

                <p>
                  <b className="highlight">6. Seating & Baggage:</b> <br/>
                  Passenger count must not exceed seating capacity. 
                  Extra luggage may incur additional charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b> <br/>
                  Driver working hours follow transport regulations. 
                  Extended usage may require additional charges or driver replacement.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b> <br/>
                  Seatbelts are mandatory. Any damage caused by passengers 
                  will be chargeable.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> <br/>
                  We reserve the right to refuse or cancel service in cases of 
                  misconduct, intoxication, or unsafe conditions.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> <br/>
                  All disputes will be governed under the applicable local jurisdiction.
                </p>

                <h3>Rental Policy</h3>
                <p>
                  <b className="highlight">Local & Outstation Use:</b> <br/>
                  Royal Route Cab services are available for local travel, outstation trips, 
                  weddings, corporate events, and tours.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b> <br/>
                  Toll charges, parking fees, and state taxes are to be borne by the customer 
                  unless mentioned in the booking.
                </p>

                <h3>Refund Policy</h3>
                <p>
                  <b className="highlight">Eligible Refunds:</b> <br/>
                  Refunds depend on cancellation timing and booking type.
                </p>

                <p>
                  <b className="highlight">Refund Timeline:</b> <br/>
                  Approved refunds are processed within 5–7 working days 
                  to the original payment method.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b><br/>
                  No refunds will be issued for no-shows or last-minute cancellations.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For Royal Route Cab support, contact us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919529877342">+91 9529877342</a></li>
              <li><b>Email:</b> <a href="mailto:booking@royalroutecabs.com">booking@royalroutecabs.com</a></li>
              <li>
                      <b>Address:</b> Royal Route Cabs,  
Shop Number 57,
Prabhat Colony Opp.<br/>
Panbai International School
Vimladevi Road,<br/>
Santacruz(E) Mumbai Maharashtra-400055.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;